import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from '../app-config.loader';
import { ProdottoSoftware } from '../shared/models/prodotto-software.model';
import { AnagraficaBaseService } from './anagrafica-base.service';

@Injectable({
  providedIn: 'root'
})
export class ProdottiSoftwareService extends AnagraficaBaseService<ProdottoSoftware> {
  constructor(appConfig: AppConfig, http: HttpClient) {
    super(http, `${appConfig.settings.apiRoot}/AnagraficaProdottiSoftware`);
  }

  get idProperty(): string {
    return 'prodottoSoftwareId';
  }

  get nameProperty(): string {
    return 'nomeProdotto';
  }
}
